import React from 'react'
import { Row, Col, InputGroup, FormControl, DropdownButton, Dropdown } from 'react-bootstrap'

const DropDownItem = ({
    children,
    onClick,
    active
}) => {
    const colStyle = {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '10px',
        marginRight: '25px',
        color: 'rgb(38, 153, 231)'
    }

    return (
        <Row><Col onClick={onClick} style={colStyle}>
            <input type="checkbox" checked={active} onChange={onClick} />
            <span style={{ paddingLeft: '10px', whiteSpace: 'nowrap', paddingTop: '3px'}} onClick={onClick}>{children}</span>
        </Col></Row>
    )
}



const DropDownFilter = ({
    title = '',
    items = [],
    values = [],
    onChange = () => {},
    disabled
}) => {
    const onSelected = (selected) => {
        if (values.includes(selected)) {
            onChange(values.filter(v => v !== selected))
        } else {
            onChange([...values, selected])
        }
    }
    title = `${title} ${values.length ? `(${values.length})` : ''}`
    return (
        <InputGroup className="mb-3">
            <FormControl
                placeholder={title}
                onChange={() => {}} 
                disabled={disabled}
            />

            <DropdownButton
                title = ''
                alignRight
                as={InputGroup.Append}
                variant="primary"
                disabled={disabled}
            >
                {items.map((item) => (
                    <DropDownItem
                        key={item.id}
                        active={values.includes(item.id)}
                        onClick={() => onSelected(item.id)}
                    >{item.name}</DropDownItem>
                ))}
                <Dropdown.Divider />
                <Dropdown.Item onClick={() => onChange([])}>Clear</Dropdown.Item>
            </DropdownButton>
        </InputGroup>
    )
}

export default DropDownFilter